var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogoutIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 61,
    viewBox: "0 0 50 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9865 39.3207C23.2289 39.3207 22.5975 39.952 22.5975 40.7096V52.7679L2.83706 57.6923V4.15587L22.5975 9.08024V21.1385C22.5975 21.8961 23.2289 22.5275 23.9865 22.5275C24.7441 22.5275 25.3753 21.8961 25.3753 21.1385V8.00697C25.3753 7.37565 24.9335 6.80745 24.3021 6.61805L1.7638 0.999239C1.32187 0.872974 0.879926 0.999254 0.564264 1.25178C0.248601 1.50431 -0.00390625 1.94623 -0.00390625 2.38816V59.5232C-0.00390625 59.9651 0.185468 60.3438 0.564264 60.6595C0.816794 60.8489 1.13247 60.9752 1.44813 60.9752C1.5744 60.9752 1.70066 60.9752 1.7638 60.912L24.3021 55.2932C24.9335 55.167 25.3753 54.5988 25.3753 53.9043V40.7727C25.3753 39.952 24.7441 39.3207 23.9865 39.3207Z",
    fill: "#1A405F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6174 29.9771L37.8116 18.1713C37.2434 17.6031 36.3596 17.6031 35.7914 18.1713C35.2232 18.7395 35.2232 19.6233 35.7914 20.1915L45.135 29.5351H13.9475C13.1899 29.5351 12.5586 30.1665 12.5586 30.924C12.5586 31.6816 13.1899 32.313 13.9475 32.313H45.2612L35.7914 41.7829C35.2232 42.351 35.2232 43.2349 35.7914 43.8031C36.0439 44.0556 36.4227 44.245 36.8015 44.245C37.1803 44.245 37.496 44.1188 37.8116 43.8031L49.6174 31.9973C50.1225 31.4291 50.1225 30.5452 49.6174 29.9771Z",
    fill: "#1A405F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoutIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LogoutIcon.f1f63c9a.svg";
export { ForwardRef as ReactComponent };